import Phaser from 'phaser';
import MainScene from 'src/app/Scenes/MainScene';
import { MemoryViewerComponent } from 'src/app/memory-viewer/memory-viewer.component';
import BaseLevelScene from 'src/app/Scenes/BaseLevelScene';

export class Memory extends Phaser.Physics.Matter.Sprite {
  static sound: Phaser.Sound.BaseSound;
  birthTime: number;
  minLifeSpan: number = 250; //(ms) Min time before this can be picked up
  public static uploadedFileNames: string[] = [];
  public static previousFileNames: string[] = [];
  constructor(scene: MainScene | BaseLevelScene, x: number, y: number, name: string, playerScale=1) {
    super(scene.matter.world, x, y, 'photo');
    this.setName(name);
    this.scene.add.existing(this);
    const Bodies = new Phaser.Physics.Matter.MatterPhysics(scene).bodies;
    var circleCollider = Bodies.circle(this.x, this.y, 10*playerScale, {
      isSensor: false,
      label: 'memoryCollider',
    });
    this.setExistingBody(circleCollider);
    this.setFrictionAir(1);
    this.setScale(playerScale);
    this.setDepth(2);
    this.birthTime = Date.now();
  }

  static preload(scene) {
    scene.load.image('photo', 'assets/items/photo32x32.png')
    scene.load.audio('pickup', 'assets/audio/pickup.mp3');
  }

  // Retrieve all filenames from public s3 bucket
  public static placeNewMemories(scene: MainScene) {
    if (Memory.uploadedFileNames && Memory.previousFileNames != Memory.uploadedFileNames) {
      // Only add new memories so we don't duplicate
      const newMemories: string[] = Memory.uploadedFileNames.filter(
        (fn) => !Memory.previousFileNames.includes(fn)
      );
      Memory.previousFileNames = Memory.uploadedFileNames;

      // Place properly formatted memories on the main scene
      if (newMemories.length > 0) {
        newMemories.forEach((fn) => {
          const { x, y } = Memory.extractCoordsFromFilename(fn);
          if (x && y) {
            console.log(`fn: ${fn}`);
            new Memory(scene, x, y, fn);
          }
        });
      }
    }
  }

  public static extractCoordsFromFilename(fileName: string): {
    x: number;
    y: number;
  } {
    // File name is at the end of the path, so split by / and reverse the split
    const tokens: string[] = fileName.split('/').reverse()[0].split('_');
    if (tokens.length <= 1) {
      return { x: NaN, y: NaN };
    }
    return { x: Number(tokens[0]), y: Number(tokens[1]) };
  }

  pickup() {
    if (Date.now() - this.birthTime >= this.minLifeSpan) {
      Memory.sound.play();
      console.log(this.name);
      MemoryViewerComponent.openModal(this.name, this.scene as (MainScene | BaseLevelScene));
      this.destroy();
      return true;
    }
    return false;
  }
}
